import { BRAND } from '@/lib/cms/config';

import { materialValueToDisplayLabel } from './plpConfig';

type LocalizedField = Record<string, string> | undefined;

function localizedValue(record: LocalizedField, localeCode: string, fallbackKey = 'EN_US'): string {
  return record?.[localeCode] || record?.[fallbackKey] || '';
}

function strapMaterialRaw(
  hit: { material?: LocalizedField; material_en?: string },
  localeCode: string
): string {
  return localizedValue(hit.material, localeCode) || hit.material_en || '';
}

/** Strap PLP/search subtitle — material label on Breitling; hidden on Gallet (Figma: name + price). */
export function getStrapCardSubtitle(
  hit: { material?: LocalizedField; material_en?: string },
  localeCode: string
): string {
  if (BRAND === 'gallet') return '';
  const rawMaterial = strapMaterialRaw(hit, localeCode);
  return rawMaterial ? materialValueToDisplayLabel(rawMaterial) : '';
}

export function getStrapCardMaterial(
  hit: { material?: LocalizedField; material_en?: string },
  localeCode: string
): string | undefined {
  const rawMaterial = strapMaterialRaw(hit, localeCode);
  return rawMaterial ? materialValueToDisplayLabel(rawMaterial) : undefined;
}

export function getWatchCardSubtitle(hit: {
  collections?: Array<{ name?: string }>;
  collection?: string;
}): string {
  return hit.collections?.[0]?.name || hit.collection || '';
}

export function getListingCardSubtitle(
  hit: Record<string, unknown>,
  productType: 'Watch' | 'Strap' | 'Eyewear',
  localeCode: string
): string {
  if (productType === 'Strap') {
    return getStrapCardSubtitle(
      hit as { material?: LocalizedField; material_en?: string },
      localeCode
    );
  }
  if (productType === 'Watch' || productType === 'Eyewear') {
    return getWatchCardSubtitle(
      hit as { collections?: Array<{ name?: string }>; collection?: string }
    );
  }
  return '';
}

export function getListingCardMaterial(
  hit: Record<string, unknown>,
  productType: 'Watch' | 'Strap' | 'Eyewear',
  localeCode: string
): string | undefined {
  if (productType === 'Strap') {
    return getStrapCardMaterial(
      hit as { material?: LocalizedField; material_en?: string },
      localeCode
    );
  }
  if (productType === 'Watch') {
    return localizedValue(hit.case as LocalizedField, localeCode) || undefined;
  }
  return undefined;
}
